import React, { useMemo } from "react";
import { translate } from "../Services/translation";
import { StockStatus } from "../constants";
import stockPackageIcon from "../../images/stock-package.svg";
import stockStopIcon from "../../images/stock-stop.svg";
import stockStoreIcon from "../../images/stock-store.svg";
import stockTruckIcon from "../../images/stock-truck.svg";
import stockWebIcon from "../../images/stock-web.svg";

const getStockBackground = (status) => {
  switch (status) {
    case StockStatus.Green:
      return "#C4D9BF";
    case StockStatus.RedLow: 
    case StockStatus.RedMedium: 
      return "#EEEACB";
    case StockStatus.Yellow: 
    case StockStatus.RedHigh:
    case StockStatus.RedHighest:
    case StockStatus.RedMax:
      return "#DED698";
    default:
      break;
  }
};

const getStockIcon = (status) => {
  switch (status) {
    case StockStatus.Green: 
    case StockStatus.Yellow:
    case StockStatus.RedHigh:
      return stockTruckIcon;
    case StockStatus.RedLow: 
    case StockStatus.RedMedium:
      return stockPackageIcon;
    case StockStatus.RedHighest:
    case StockStatus.RedMax:
      return stockStopIcon;
    default:
      break;
  }
};

const removeColonAndNumber = (status) => {
  const regex = /:([0-9]+)$/;

  const match = status.match(regex);

  let resultString;
  if (match) {
    resultString = status.replace(regex, '');
  } else {
    resultString = status;
  }

  return resultString;
}

const ProductStockStatus = ({ status, statusText, storeStatus }) => {

  const formattedStatus = useMemo(() => removeColonAndNumber(status), [status]);

  return (
    <>
      <div
        className={`product-stock-status__banner ${
          storeStatus === "False"
            ? "product-stock-status__banner--disabled"
            : ""
        }`}
      >
        <img
          src={storeStatus === "False" ? stockWebIcon : stockStoreIcon}
          className="product-stock-status__icon"
        />
        <span className="product-stock-status__text">
          {translate(
            storeStatus === "False"
              ? "stockstatus.not-in-store"
              : "stockstatus.in-store"
          )}
        </span>
      </div>
      <div
        className="product-stock-status__banner"
        style={{ background: `${getStockBackground(formattedStatus)}` }}
      >
        <img src={getStockIcon(formattedStatus)} className="product-stock-status__icon"/>
        <div className="product-stock-status__banner-content">
          <strong>
            {translate("stockstatus.stock-title-" + formattedStatus.toLowerCase())}
          </strong>
          {statusText && status != StockStatus.Yellow && <i>
            {statusText}
          </i>}
        </div>
      </div>
    </>
  );
};

export default ProductStockStatus;
